<!--suppress HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<div class="row">
  <div class="col-12 col-md-10">
    <nav class="breadcrumb-one" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="javascript:void(0);">
            <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </a>
        </li>
        <li class="breadcrumb-item">
          <a [routerLink]="'/private/koshk'" translate>Koshk</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page" translate>Website Pages</li>
      </ol>
    </nav>
  </div>
  <div class="col-12 col-md-2 mt-3">
    <button class="btn btn-primary" [routerLink]="'/private/webpages/new'" translate>New Website Page</button>
  </div>
</div>
<div [hidden]="loading" class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
  <div class="widget-content widget-content-area br-6">
    <div class="table-responsive mb-4 mt-4">
      <table id="multi-column-ordering" class="table table-hover" style="width:100%">
        <thead>
        <tr>
          <th translate>ID</th>
          <th translate>Name</th>
          <th translate>URL</th>
          <th translate>Rank</th>
          <th translate>Type</th>
          <th translate>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="websitePages == null || websitePages.length == 0">
          <td colspan="6" style="text-align: center;font-size: 12pt;color: cadetblue">
            {{ 'No pages have been created yet. The default view will be displayed on your store website.' | translate }}
          </td>
        </tr>
        <tr *ngFor="let websitePage of websitePages">
          <!--          ID -->
          <td>
            <span>{{ websitePage.id }}</span>
          </td>
          <!--Name -->
          <td>
            <p class="align-self-center mb-0 admin-name">{{ lang == 'ar' && websitePage.name_locale && websitePage.name_locale[lang] ? websitePage.name_locale[lang] : websitePage.name }}</p>
          </td>
          <!--URL -->
          <td>
            <p class="align-self-center mb-0 admin-name">{{ websitePage.url }}</p>
          </td>
          <!--Rank -->
          <td>
            <p class="align-self-center mb-0 admin-name">{{ websitePage.rank }}</p>
          </td>
          <!--Rank -->
          <td>
            <p class="align-self-center mb-0 admin-name">{{ websitePage.type }}</p>
          </td>
          <!--     Action     -->
          <td class="text-center">
            <div class="dropdown">
              <a class="dropdown-toggle2" href="#" role="button" [id]="'dropdownMenuLink_' + websitePage.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="19" cy="12" r="1"></circle>
                  <circle cx="5" cy="12" r="1"></circle>
                </svg>
              </a>
              <div class="dropdown-menu" [attr.aria-labelledby]="'dropdownMenuLink_' + websitePage.id" style="will-change: transform;">
                <a class="dropdown-item" [routerLink]="['/private', 'webpages', 'edit', websitePage.id]" [queryParams]="{type: subAccountType, govId: subAccountGovId}" href="javascript:void(0);" translate>Edit</a>
                <a [hidden]="!isSales && !isMerchant && !isManager" class="dropdown-item" href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#deleteModal' + websitePage.id" translate>Delete</a>
              </div>
            </div>
          </td>

          <!-- Modal -->
          <div class="modal fade" [id]="'deleteModal' + websitePage.id" tabindex="-1" role="dialog" [attr.aria-labelledby]="'deleteModalLabel' + websitePage.id" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" [id]="'deleteModalLabel' + websitePage.id">{{ 'Delete WebsitePage' | translate }}</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
                </div>
                <div class="modal-body">
                  <p class="modal-text">{{ 'Do you want to delete websitePage of title' | translate }} "{{ lang == 'ar' && websitePage.name_locale && websitePage.name_locale[lang] ? websitePage.name_locale[lang] : websitePage.name }}"</p>
                </div>
                <div class="modal-footer">
                  <button class="btn" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>No</button>
                  <button type="button" data-dismiss="modal" class="btn btn-primary" (click)="deleteWebsitePage(websitePage.id, lang == 'ar' ? websitePage.name_locale[lang] : websitePage.name)" translate>Yes</button>
                </div>
              </div>
            </div>
          </div>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th translate>ID</th>
          <th translate>Name</th>
          <th translate>URL</th>
          <th translate>Rank</th>
          <th translate>Type</th>
          <th translate>Actions</th>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
